<div
  class="checkbox-container"
  [ngClass]="{
    outer_layer: outerLayer,
    value__selected: isChecked,
    disabled: isDisabled,
    'no-label': !label
  }"
>
  <label class="custom-checkbox-wrapper">
    <ng-container *ngIf="isFormGroup; else modelTemplate">
      <input type="checkbox" [formControl]="checkboxFormControl" (change)="onClicked()" />
    </ng-container>
    <ng-template #modelTemplate>
      <input type="checkbox" [ngModel]="model" (ngModelChange)="modelChange.emit($event)" [disabled]="isDisabled" />
    </ng-template>

    <span class="custom-checkbox"></span>
    <div class="text_grouping">
      <span class="checkbox-label" [class.disabled-label]="isDisabled" [class.small-label]="smallLabel">{{
        label
      }}</span>
      <span class="checkbox-description" [class.disabled-label]="isDisabled">{{ description }}</span>
    </div>
  </label>
</div>
